import type { FindexAsset } from '@/types/models/asset'
import { getRefId, type FindexInvestment, type FullAsset, type FullInvestment } from 'findef'

export type FindexAssetMap = Record<string, FindexAsset | FullAsset>

export const createAssetMap = (assets: (FindexAsset | FullAsset)[]): FindexAssetMap => {
  return Object.assign(
    {},
    ...assets.map((asset) => ({
      [getRefId(asset)]: asset
    }))
  )
}

export type FindexInvestmentMap = Record<string, FindexInvestment | FullInvestment>;


export const createInvestmentMap = (investments: (FindexInvestment | FullInvestment)[]): FindexInvestmentMap => {
  return Object.assign(
    {},
    ...investments.map((inv) => ({
      [getRefId(inv)]: inv
    }))
  )
}
